export const STOREFRONT_PALETTES = ['violet', 'pink', 'cyan', 'ink', 'rose'];
export const DEFAULT_STOREFRONT_PALETTE = 'violet';
export const DEFAULT_STOREFRONT_MODULES = {
    about: true,
    schedule: true,
    clips: false,
    wishlist: false,
    fanClub: false,
    social: false,
};
export function isStorefrontPalette(value) {
    return (typeof value === 'string' &&
        STOREFRONT_PALETTES.includes(value));
}
export function parseStorefrontPalette(value) {
    return isStorefrontPalette(value) ? value : DEFAULT_STOREFRONT_PALETTE;
}
export function parseStorefrontModules(value) {
    if (!value || typeof value !== 'object') {
        return { ...DEFAULT_STOREFRONT_MODULES };
    }
    const row = value;
    return {
        about: typeof row.about === 'boolean' ? row.about : DEFAULT_STOREFRONT_MODULES.about,
        schedule: typeof row.schedule === 'boolean' ? row.schedule : DEFAULT_STOREFRONT_MODULES.schedule,
        clips: typeof row.clips === 'boolean' ? row.clips : DEFAULT_STOREFRONT_MODULES.clips,
        wishlist: typeof row.wishlist === 'boolean' ? row.wishlist : DEFAULT_STOREFRONT_MODULES.wishlist,
        fanClub: typeof row.fanClub === 'boolean' ? row.fanClub : DEFAULT_STOREFRONT_MODULES.fanClub,
        social: typeof row.social === 'boolean' ? row.social : DEFAULT_STOREFRONT_MODULES.social,
    };
}
//# sourceMappingURL=storefront-appearance.js.map